"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeFetchWithPrevious = exports.getContentOrPrevious = exports.getUnexpiredDataOrPrevious = exports.getDataOrPrevious = void 0;
const models_1 = require("./models");
const typeGuards_1 = require("./typeGuards");
/**
 * Returns the current data if exists, previous data if exists, or undefined.
 */
const getDataOrPrevious = (val) => {
    var _a;
    switch (val === null || val === void 0 ? void 0 : val.type) {
        case models_1.LCEType.Content:
            return val.data;
        case models_1.LCEType.Fetching:
        case models_1.LCEType.Error:
            return (_a = val.previousContent) === null || _a === void 0 ? void 0 : _a.data;
        default:
            return undefined;
    }
};
exports.getDataOrPrevious = getDataOrPrevious;
/**
 * Returns current or previous data if they are unexpired, otherwise returns undefined.
 */
const getUnexpiredDataOrPrevious = (val) => {
    if (val == null) {
        return undefined;
    }
    else if (typeGuards_1.isUnexpiredContent(val)) {
        return val.data;
    }
    else if ("previousContent" in val && typeGuards_1.isUnexpiredContent(val.previousContent)) {
        return val.previousContent.data;
    }
    return undefined;
};
exports.getUnexpiredDataOrPrevious = getUnexpiredDataOrPrevious;
/**
 * Returns the current content if exists, previous content if exists, or undefined.
 */
const getContentOrPrevious = (val) => {
    switch (val === null || val === void 0 ? void 0 : val.type) {
        case models_1.LCEType.Content:
            return val;
        case models_1.LCEType.Fetching:
        case models_1.LCEType.Error:
            return val.previousContent;
        default:
            return undefined;
    }
};
exports.getContentOrPrevious = getContentOrPrevious;
/**
 * Reverts a Fetching state to its previous content if available, or a NotRequested state if not available.
 * All other states are returned unchanged.
 * This can be used to handle cancellation of a fetch request (e.g. if data has not expired yet).
 */
const completeFetchWithPrevious = (val) => {
    var _a;
    if (typeGuards_1.isFetching(val)) {
        return (_a = val.previousContent) !== null && _a !== void 0 ? _a : models_1.LCE_NOT_REQUESTED;
    }
    else {
        return val;
    }
};
exports.completeFetchWithPrevious = completeFetchWithPrevious;
//# sourceMappingURL=getDataOrPrevious.js.map